import React from 'react';
import { AlertTriangle, Siren, Gavel, DollarSign } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-slate-50 border-y border-slate-200" data-id="element-139">
      <div className="container mx-auto px-4" data-id="element-140">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-142">
            El Sistema No Tiene Compasión
          </h2>
          <p className="text-lg text-slate-600" data-id="element-143">
            Vivir en EE. UU. sin papeles es un riesgo. Vivir sin un plan de
            contingencia es una imprudencia que puede costarte todo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-144">
          {/* Fear 1 */}
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-red-600" data-id="element-145">
            <div className="bg-red-100 w-14 h-14 rounded-full flex items-center justify-center mb-6" data-id="element-146">
              <Siren className="w-8 h-8 text-red-600" data-id="element-147" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-148">
              El Miedo a Foster Care
            </h3>
            <p className="text-slate-600" data-id="element-149">
              Si te detienen y no hay un tutor legal designado por escrito, el
              estado toma custodia inmediata de tus hijos. Recuperarlos del
              sistema de Foster Care puede tomar meses o años.
            </p>
          </div>

          {/* Fear 2 */}
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-red-600" data-id="element-150">
            <div className="bg-red-100 w-14 h-14 rounded-full flex items-center justify-center mb-6" data-id="element-151">
              <DollarSign className="w-8 h-8 text-red-600" data-id="element-152" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-153">
              Activos Congelados
            </h3>
            <p className="text-slate-600" data-id="element-154">
              Tu dinero, tu auto y tus ahorros pueden quedar bloqueados si nadie
              tiene un poder notarial para acceder a ellos en tu nombre. Años de
              trabajo perdidos en un instante.
            </p>
          </div>

          {/* Fear 3 */}
          <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-red-600" data-id="element-155">
            <div className="bg-red-100 w-14 h-14 rounded-full flex items-center justify-center mb-6" data-id="element-156">
              <Gavel className="w-8 h-8 text-red-600" data-id="element-157" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-158">
              Sin Defensa Legal
            </h3>
            <p className="text-slate-600" data-id="element-159">
              Sin un plan previo, tu familia queda a merced de abogados públicos
              sobrecargados o estafadores que se aprovechan de la desesperación
              del momento.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mt-12 bg-red-50 border border-red-200 rounded-lg p-6 flex items-start gap-4" data-id="element-160">
          <AlertTriangle className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" data-id="element-161" />
          <div data-id="element-162">
            <h4 className="font-bold text-red-800 text-lg" data-id="element-163">
              La Realidad Brutal
            </h4>
            <p className="text-red-700" data-id="element-164">
              No necesitas ser un criminal para ser deportado. Una infracción de
              tráfico, una redada en el trabajo o simplemente estar en el lugar
              equivocado puede detonar la pesadilla. ¿Estás preparado?
            </p>
          </div>
        </div>
      </div>
    </section>;
}